
<header class="">
  <div class="header-top d-flex flex-wrap align-items-center justify-content-center justify-content-md-between">
    <div class="container">
      <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between">
        <div class="col-md-6">
          <a href="/" class="d-inline-flex link-body-emphasis text-decoration-none logo">
            <img class="logo-mini navbar-brand" src="assets\img\EY_Logo.png">
            <span>Contract Management Tool</span>
          </a>
        </div>
        <div class="col-md-6 text-end">
          <div class="d-flex align-items-center justify-content-end column-gap-3">
            <span class="welcome-heading pull-left">
              Welcome, {{FullName}}
            </span>
            <span class="faicon" (click)="AddToFavourite();">
              <i class="fa fa-star" title="Add as favourites"></i>
            </span>
            <span class="faicon" (click)="logout();">
              <i class="fa fa-sign-out" title="Logout"></i>
            </span>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <i class="fa fa-bars"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="header-bottom">
    <div class="container">
      <div class="navbar-collapse collapse" id="navbarSupportedContent">
        <ul class="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
          <li>
            <a [routerLink]="['/INFTE/home']" class="nav-link px-2 text-secondary">
              <i class="fa fa-home" ></i>
            </a>
          </li>

          <li class="nav-item dropdown" *ngIf="IsPartner || IsAdmin || IsFinanceTeam || IsSLHR || IsCounsellor">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Contracts
            </a>
            <ul class="dropdown-menu">
              <li>
                <a  class="dropdown-item" [routerLink]="['/View/ViewPendingForRenewal/1']" *ngIf="IsCounsellor || IsAdmin">
                  Pending for
                  Renewal
                </a>
              </li>
              <li>
                <a  class="dropdown-item" [routerLink]="['/View/ViewPendingForApproval/2']" *ngIf="IsPartner || IsAdmin">
                  Pending for
                  Approval
                </a>
              </li>
              <li>
                <a  class="dropdown-item" [routerLink]="['/View/ViewPendingwithFinanceTeam/5']" *ngIf="IsFinanceTeam || IsAdmin">
                  Pending with Finance Team
                </a>
              </li>
              <li>
                <a  class="dropdown-item" [routerLink]="['/View/ViewPendingForEnd/3']" *ngIf="IsSLHR || IsAdmin">Pending for Closure</a>
              </li>
              <li>
                <a  class="dropdown-item" [routerLink]="['/View/ViewPendingToBeInitiated/6']" *ngIf="IsSLHR || IsAdmin">Pending to be Initiated</a>
              </li>
            </ul>
          </li>
          <li class="nav-item px-2 text-white" *ngIf="IsCounsellor || IsAdmin || IsFinanceTeam || IsSLHR || IsPartner">
            <a [routerLink]="['/View/ViewAll/4']" class="nav-link">
              <font color="white">View Records</font>
            </a>
          </li>
          <li class="nav-item dropdown" *ngIf="IsAdmin">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Access Matrix
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" [routerLink]="['/View/GrantAccessMatrixComponent']" *ngIf="IsAdmin">
                  Grant SLHR Matrix Access 
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/BulkUploadAccessMatrixComponent']" *ngIf="IsAdmin">
                  Bulk Upload SLHR Matrix
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/ViewAccessMatrixRecordComponent']" *ngIf="IsAdmin">
                  View SLHR Matrix Records
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/CreateFinanceUserMappingComponent']" *ngIf="IsAdmin">
                  Create Finance User Mapping
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/ViewFinanceUserMappingComponent']" *ngIf="IsAdmin">
                  View Finance User Mapping Records
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item px-2 text-white" *ngIf="IsAdmin">
            <a [routerLink]="['/View/InitiateRecordsFteComponent']" class="nav-link">
              <font color="white">Initiate Record</font>
            </a>
          </li>
          <li class="nav-item dropdown" *ngIf="IsManager || IsAdmin1 || IsBUOUSpoc">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              FTE Records
            </a>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" [routerLink]="['/View/FTERecords/1']" *ngIf="IsAdmin1 || IsManager || IsBUOUSpoc">
                  View all FTE
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/PendingForEngagementCodeUpdate/2']" *ngIf="IsManager || IsAdmin1 || IsBUOUSpoc">
                  Pending for Engagement Code update
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/PendingForEngagementCodeReview/3']" *ngIf="IsManager || IsAdmin1 || IsBUOUSpoc">
                  Pending for Engagement Code review
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/TransitionedRecords/4']" *ngIf="IsManager || IsAdmin1 || IsBUOUSpoc || IsPartner">
                  View Transitioned Records
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/FTEReview']" *ngIf="IsManager || IsAdmin1 || IsBUOUSpoc || IsPartner">
                  View Reviewed Records
                </a>
              </li>
              <li>
                <a class="dropdown-item" [routerLink]="['/View/RecordsExport']" *ngIf="IsManager || IsAdmin1 || IsBUOUSpoc || IsPartner">
                  Export Employee Records
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
